'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DirectiveId$() {
  this.c5r = null;
  this.c5s = false;
  this.c5p = null;
  this.c5q = false;
}
export { $c_Lpresto_types$DirectiveId$ as $c_Lpresto_types$DirectiveId$ };
$p = $c_Lpresto_types$DirectiveId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectiveId$;
/** @constructor */
function $h_Lpresto_types$DirectiveId$() {
}
export { $h_Lpresto_types$DirectiveId$ as $h_Lpresto_types$DirectiveId$ };
$h_Lpresto_types$DirectiveId$.prototype = $p;
$p.ady = (function() {
  if ((!this.c5s)) {
    this.c5r = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j0;
    this.c5s = true;
  }
  return this.c5r;
});
$p.v2 = (function() {
  if ((!this.c5q)) {
    this.c5p = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().dZ;
    this.c5q = true;
  }
  return this.c5p;
});
var $d_Lpresto_types$DirectiveId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveId$, "presto.types$DirectiveId$", ({
  Zv: 1,
  D: 1
}));
export { $d_Lpresto_types$DirectiveId$ as $d_Lpresto_types$DirectiveId$ };
var $n_Lpresto_types$DirectiveId$;
function $m_Lpresto_types$DirectiveId$() {
  if ((!$n_Lpresto_types$DirectiveId$)) {
    $n_Lpresto_types$DirectiveId$ = new $c_Lpresto_types$DirectiveId$();
  }
  return $n_Lpresto_types$DirectiveId$;
}
export { $m_Lpresto_types$DirectiveId$ as $m_Lpresto_types$DirectiveId$ };
//# sourceMappingURL=presto.types$-Directive-Id$.js.map
